import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import {currency, Portal} from '../../../../../util';

interface IPayLaterProps {
    isMobile: boolean;
}

const PayLater = observer(({isMobile}: IPayLaterProps) => {
    return (
        <>
            {isMobile && store.checkout.cart.items && store.checkout.cart.items.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        fontSize: 14,
                        marginTop: 16,
                    }}
                >
                    <div>
                        <picture>
                            <source
                                type="image/webp"
                                srcSet={`https://${Portal?.CDNDomain}/images/cached/general/ppa25.webp`}
                            />
                            <img
                                width="94"
                                height="26"
                                loading="lazy"
                                src={`https://${Portal?.CDNDomain}/images/cached/general/ppa25.jpg`}
                                alt="PayPal Pay Later"
                                style={{height: 16, width: 'auto'}}
                            />
                        </picture>
                    </div>

                    <div style={{fontSize: 14, paddingLeft: 6, marginTop: 2}}>
                        Pay in 4 payments of {currency(store.checkout.cart.pricing.total / 4)}.{' '}
                        <a
                            href="https://www.paypal.com/us/digital-wallet/ways-to-pay/buy-now-pay-later"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link"
                            style={{fontSize: 14, textDecoration: 'underline'}}
                        >
                            Learn More.
                        </a>
                    </div>
                </div>
            )}
        </>
    );
});

export default PayLater;
